import { Pipe, PipeTransform } from '@angular/core';
import { GameViewFlatModel } from '../models/GameModels';

interface DivisionGroup {
  DivisionName: string;
  Games: GameViewFlatModel[];
}

interface DateGroup {
  GroupDate: Date;
  Divisions: DivisionGroup[];
}

@Pipe({
  name: 'groupByDateAndDivision',
  standalone: true
})
export class GroupByDateAndDivisionPipe implements PipeTransform {
  transform(games: GameViewFlatModel[], dateProperty: string, useLocalTimezone: boolean = false, sort: 'asc' | 'desc' = 'asc'): DateGroup[] {
    if (!games || !games.length) {
      return [];
    }

    //console.log('sort:', sort);

    // Felsökningsloggning: Logga GameTimeUTC och GameTime för varje spel
   /*  games.forEach(game => {
      // console.log('Game:', game.GameId, 'GameTimeUTC:', game.GameTimeUTC, 'GameTime:', game.GameTime);
    }); */

    // Gruppera först efter datum
    const dateGroups: { [key: string]: GameViewFlatModel[] } = {};
    games.forEach(game => {
      let date: Date;
      if (dateProperty === 'GameTimeUTC') {
        date = new Date(game.GameTimeUTC);
      } else {
        date = new Date(game.GameDate);
      }

      // Använd lokal tidszon för datumgruppering när GameTimeUTC används
      const dateKey = date.toLocaleDateString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).split('-').join('-');

      if (!dateGroups[dateKey]) {
        dateGroups[dateKey] = [];
      }
      dateGroups[dateKey].push(game);
    });

    // Skapa slutlig struktur med datum och ligor
    const result: DateGroup[] = [];
    Object.keys(dateGroups).forEach(dateKey => {
      const gamesForDate = dateGroups[dateKey];
      const divisionGroups: { [key: string]: GameViewFlatModel[] } = {};
      gamesForDate.forEach(game => {
        const division = game.DivisionName || 'Unknown';
        if (!divisionGroups[division]) {
          divisionGroups[division] = [];
        }
        divisionGroups[division].push(game);
      });

      const divisions: DivisionGroup[] = Object.keys(divisionGroups).map(division => {
        // Sortera spelen inom varje division efter tid
        const sortedGames = divisionGroups[division].sort((a, b) => {
          // Validera tid för att undvika ogiltiga datum
          const timeA = dateProperty === 'GameTimeUTC' ? a.GameTimeUTC : a.GameTime;
          const timeB = dateProperty === 'GameTimeUTC' ? b.GameTimeUTC : b.GameTime;

          // Om tid saknas eller är ogiltig, placera sist
          if (!timeA || isNaN(new Date(timeA).getTime())) return 1;
          if (!timeB || isNaN(new Date(timeB).getTime())) return -1;

          const dateA = new Date(timeA);
          const dateB = new Date(timeB);
          return dateA.getTime() - dateB.getTime();
        });
        return {
          DivisionName: division,
          Games: sortedGames
        };
      });

      result.push({
        GroupDate: new Date(dateKey),
        Divisions: divisions
      });
    });

    // console.log('Grouped Result:', result);
    // Sortera datumgrupper efter GroupDate
    if (sort === 'desc') {
      return result.sort((a, b) => a.GroupDate.getTime() - b.GroupDate.getTime());
    } else {
      return result.sort((a, b) => b.GroupDate.getTime() - a.GroupDate.getTime());
    } 
  }
}